<template>
  <div class="hello">
    <div v-if="mobile" style="width: 95%;left:2.5%;position:relative;">
      <h1> WireGuard 协议获取 </h1>
    <Input v-model="account"  placeholder="账号" style="width:15%; margin: 0.675rem;font-size:10px;" ></Input> 
    <Input type="password" v-model="passwd" placeholder="密码"  style="width:15%; margin: 0.675rem;"></Input>

    <Select v-model="cityCode" style="width:24%; margin: 0.675rem;" filterable >
      <Option v-for="item in cityList" :value="item.cityCode" :key="item.cityCode" style="display:block" >{{ item.city }}</Option>
    </Select> 

    <Button type="primary" style="width:14%;font-size:10px;"  size="large" @click="select" :loading="selectLoading" >获取</Button> 
    <h2 v-html='msg' ></h2>

    </div>
    <div v-else style="width: 60%;left: 20%;position:relative;">
      <h1> WireGuard 协议获取 </h1>
    <Input v-model="account" size="large" placeholder="账号" style="width:20%; margin: 0.675rem;" ></Input> 
    <Input type="password" v-model="passwd" size="large" placeholder="密码"  style="width:20%; margin: 0.675rem;"></Input>

    <Select v-model="cityCode" style="width:20%; margin: 0.675rem;" filterable >
      <Option v-for="item in cityList" :value="item.cityCode" :key="item.cityCode" style="display:block" >{{ item.city }}</Option>
    </Select> 

    <Button type="primary" style="width:8%;"  size="large" @click="select" :loading="selectLoading" >获取</Button> 
    <h2 v-html='msg' ></h2>
    </div>
  </div>
</template>
 
<script>
export default {
  name: 'HelloWorld',
  data () {
    return {
      selectLoading:false,
      mobile:false,
      account:"",
      passwd:"",
      cityCode:"HK",
      cityList: [],
      hostPort:"https://api.fengqin.link",
      //hostPort:"http://localhost:7778",
      msgLeft:'<p style="text-align:left ;left: 14%;position:relative;"></br>',
      msg:" "
    }
  },
  mounted:function(){
    this._data.mobile=this.isMobile()
    this.getCityList();
  },
  methods:{
    getCityList(){
        let _this=this;
        _this.axios.get(_this._data.hostPort+'/vpn/getCityList') .then(function (response) {
                console.log(response)
                _this._data.cityList=response.data.datas
            })
            .catch(function (error) {
           
            console.log(error)
        });
    },
    select()  {
        let _this=this;
        _this._data.selectLoading=true;
        _this._data.msg="";
        if(_this._data.account==""||_this._data.passwd==""||_this._data.cityCode==""){
            _this.$Modal.warning({
                title: '提示',
                content: "数据不能为空"
            })
            _this._data.selectLoading=false;
            return
        }
        
        let param={
              account:_this._data.account,
              password :_this._data.passwd,
              cityCode :_this._data.cityCode
        }
        _this.axios.get(_this._data.hostPort+'/vpn/getVpn',
            {
                params: param
            },{timeout:15000}) .then(function (response) {
                _this._data.msg=_this._data.msgLeft+response.data.data+"</p>"
                _this._data.selectLoading=false;
            })
            .catch(function (error) {
            _this._data.msg=_this._data.msgLeft+error.message+"</p>"
            console.log(error)
            _this._data.selectLoading=false;
        });
        },
    isMobile(){
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
	    return flag;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/components/myvpn.vue